import { type Images } from '@neos/app'
import aiWritingAssistantPath from '../../modules/dependencies/NeosAICore/images/AIWritingAssistant.svg'
import aiWritingAssistantDarkVersionPath from '../../modules/dependencies/NeosAICore/images/AIWritingAssistant.dark.svg'
import aiWritingAssistantTaskPerformerPath from '../../modules/dependencies/NeosAICore/images/AIWritingAssistantTaskPerformer.svg'
import activeTenantStatusPath from '../../modules/Tenants/images/ActiveTenantStatus.svg'
import administratorUserAccountForRequestsPath from '../../modules/NeosDiagnostics/images/AdministratorUserAccountForRequests.svg'
import chatbotPath from '../../modules/Tenants/images/Chatbot.svg'
import clusterPath from '../../modules/Tenants/images/Cluster.svg'
import clustersPath from '../../modules/Tenants/images/Clusters.svg'
import collapsePath from '../../modules/UserPermissions/images/Collapse.svg'
import connectivityPath from '../../modules/NeosDeployment/images/Connectivity.svg'
import copyPath from '../../modules/Tenants/images/Copy.svg'
import correctTextPath from '../../modules/dependencies/NeosAICore/images/CorrectText.svg'
import createCustomViewPath from '../../modules/UICustomization/images/CreateCustomView.svg'
import createCustomViewDarkVersionPath from '../../modules/UICustomization/images/CreateCustomView.dark.svg'
import customViewPath from '../../modules/UICustomization/images/CustomView.svg'
import customViewDefaultViewPath from '../../modules/UICustomization/images/CustomViewDefaultView.svg'
import customViewFilterPath from '../../modules/UICustomization/images/CustomViewFilter.svg'
import customViewGroupsPath from '../../modules/UICustomization/images/CustomViewGroups.svg'
import customViewKeyPath from '../../modules/UICustomization/images/CustomViewKey.svg'
import customViewPropertyPath from '../../modules/UICustomization/images/CustomViewProperty.svg'
import customViewRelationshipPath from '../../modules/UICustomization/images/CustomViewRelationship.svg'
import customViewSavePath from '../../modules/UICustomization/images/CustomViewSave.svg'
import customViewSelectedPath from '../../modules/UICustomization/images/CustomViewSelected.svg'
import customViewSetDefaultViewPath from '../../modules/UICustomization/images/CustomViewSetDefaultView.svg'
import customViewSortPath from '../../modules/UICustomization/images/CustomViewSort.svg'
import databasePath from '../../modules/Tenants/images/Database.svg'
import databaseConnectionTestPath from '../../modules/Tenants/images/DatabaseConnectionTest.svg'
import databaseConnectionTestDarkVersionPath from '../../modules/Tenants/images/DatabaseConnectionTest.dark.svg'
import databaseSyncPath from '../../modules/Tenants/images/DatabaseSync.svg'
import disableNotificationsPath from '../../modules/NeosNotificationCenter/images/DisableNotifications.svg'
import downPath from '../../modules/UserPermissions/images/Down.svg'
import downgradePath from '../../modules/Tenants/images/Downgrade.svg'
import editCustomViewPath from '../../modules/UICustomization/images/EditCustomView.svg'
import editCustomViewDarkVersionPath from '../../modules/UICustomization/images/EditCustomView.dark.svg'
import enableNotificationsPath from '../../modules/NeosNotificationCenter/images/EnableNotifications.svg'
import errorClusterPath from '../../modules/UserPermissions/images/ErrorCluster.svg'
import expandPath from '../../modules/UserPermissions/images/Expand.svg'
import extendedEntityPath from '../../modules/Tenants/images/ExtendedEntity.svg'
import externalClusterPath from '../../modules/UserPermissions/images/ExternalCluster.svg'
import eyePath from '../../modules/Tenants/images/Eye.svg'
import eyeOffPath from '../../modules/Tenants/images/EyeOff.svg'
import failurePath from '../../modules/Tenants/images/Failure.svg'
import idPath from '../../modules/Tenants/images/ID.svg'
import improveTextPath from '../../modules/dependencies/NeosAICore/images/ImproveText.svg'
import inactiveTenantStatusPath from '../../modules/Tenants/images/InactiveTenantStatus.svg'
import licensePath from '../../modules/Tenants/images/License.svg'
import multiTenantPath from '../../modules/Tenants/images/MultiTenant.svg'
import neosPath from '../../modules/Tenants/images/Neos.svg'
import neosBarChartPath from '../../modules/NeosDashboard/images/NeosBarChart.svg'
import neosDashboardPath from '../../modules/NeosDashboard/images/NeosDashboard.svg'
import neosDashboardAddPath from '../../modules/NeosDashboard/images/NeosDashboardAdd.svg'
import neosDashboardClockPath from '../../modules/NeosDashboard/images/NeosDashboardClock.svg'
import neosDashboardDisplayPath from '../../modules/NeosDashboard/images/NeosDashboardDisplay.svg'
import neosDashboardDoughnutChartPath from '../../modules/NeosDashboard/images/NeosDashboardDoughnutChart.svg'
import neosDashboardEditDashboardPath from '../../modules/NeosDashboard/images/NeosDashboardEditDashboard.svg'
import neosDashboardExpandViewPath from '../../modules/NeosDashboard/images/NeosDashboardExpandView.svg'
import neosDashboardGaugeChartPath from '../../modules/NeosDashboard/images/NeosDashboardGaugeChart.svg'
import neosDashboardHomePath from '../../modules/NeosDashboard/images/NeosDashboardHome.svg'
import neosDashboardLineChartPath from '../../modules/NeosDashboard/images/NeosDashboardLineChart.svg'
import neosDashboardNoneChartPath from '../../modules/NeosDashboard/images/NeosDashboardNoneChart.svg'
import neosDashboardPieChartPath from '../../modules/NeosDashboard/images/NeosDashboardPieChart.svg'
import neosDashboardSettingPath from '../../modules/NeosDashboard/images/NeosDashboardSetting.svg'
import neosDashboardSharedPath from '../../modules/NeosDashboard/images/NeosDashboardShared.svg'
import neosDashboardTilePath from '../../modules/NeosDashboard/images/NeosDashboardTile.svg'
import neosDashboardTileChartPath from '../../modules/NeosDashboard/images/NeosDashboardTileChart.svg'
import neosDataImportDetailPath from '../../modules/NeosDataExchange/images/NeosDataImportDetail.svg'
import neosDataImportDownloadFilePath from '../../modules/NeosDataExchange/images/NeosDataImportDownloadFile.svg'
import neosDataImportErrorPath from '../../modules/NeosDataExchange/images/NeosDataImportError.svg'
import neosDataImportFilePath from '../../modules/NeosDataExchange/images/NeosDataImportFile.svg'
import neosDataImportHistoryPath from '../../modules/NeosDataExchange/images/NeosDataImportHistory.svg'
import neosDataImportIntegratePath from '../../modules/NeosDataExchange/images/NeosDataImportIntegrate.svg'
import neosDataImportIntegrateAllPath from '../../modules/NeosDataExchange/images/NeosDataImportIntegrateAll.svg'
import neosDataImportIntegrationPath from '../../modules/NeosDataExchange/images/NeosDataImportIntegration.svg'
import neosDataImportKpiErrorRowCountPath from '../../modules/NeosDataExchange/images/NeosDataImportKpiErrorRowCount.svg'
import neosDataImportKpiInformationRowCountPath from '../../modules/NeosDataExchange/images/NeosDataImportKpiInformationRowCount.svg'
import neosDataImportKpiIntegratedRowCountPath from '../../modules/NeosDataExchange/images/NeosDataImportKpiIntegratedRowCount.svg'
import neosDataImportKpiProcessedRowCountPath from '../../modules/NeosDataExchange/images/NeosDataImportKpiProcessedRowCount.svg'
import neosDataImportKpiValidRowCountPath from '../../modules/NeosDataExchange/images/NeosDataImportKpiValidRowCount.svg'
import neosDataImportKpiWarningRowCountPath from '../../modules/NeosDataExchange/images/NeosDataImportKpiWarningRowCount.svg'
import neosDataImportRightArrowPath from '../../modules/NeosDataExchange/images/NeosDataImportRightArrow.svg'
import neosDataImportRunPath from '../../modules/NeosDataExchange/images/NeosDataImportRun.svg'
import neosDataImportSettingsPath from '../../modules/NeosDataExchange/images/NeosDataImportSettings.svg'
import neosDataImportTemplatePath from '../../modules/NeosDataExchange/images/NeosDataImportTemplate.svg'
import neosDataImportUploadFilePath from '../../modules/NeosDataExchange/images/NeosDataImportUploadFile.svg'
import neosDiagnosticsAdminUserAccountPath from '../../modules/NeosDiagnostics/images/NeosDiagnosticsAdminUserAccount.svg'
import neosDiagnosticsDownloadPath from '../../modules/NeosDiagnostics/images/NeosDiagnosticsDownload.svg'
import neosDiagnosticsLaunchPath from '../../modules/NeosDiagnostics/images/NeosDiagnosticsLaunch.svg'
import neosDiagnosticsOpenInNewPath from '../../modules/NeosDiagnostics/images/NeosDiagnosticsOpenInNew.svg'
import neosDiagnosticsUserAccountPath from '../../modules/NeosDiagnostics/images/NeosDiagnosticsUserAccount.svg'
import notificationCenterPath from '../../modules/NeosNotificationCenter/images/NotificationCenter.svg'
import notificationCenterEmptyPath from '../../modules/NeosNotificationCenter/images/NotificationCenterEmpty.svg'
import omniaPath from '../../modules/dependencies/NeosAICore/images/Omnia.svg'
import openInNewPath from '../../modules/NeosDiagnostics/images/OpenInNew.svg'
import oraclePath from '../../modules/Tenants/images/Oracle.svg'
import performTaskOnTextPath from '../../modules/dependencies/NeosAICore/images/PerformTaskOnText.svg'
import postGrePath from '../../modules/Tenants/images/PostGre.svg'
import propertyPath from '../../modules/Tenants/images/Property.svg'
import queryaPath from '../../modules/dependencies/NeosAICore/images/Querya.svg'
import quickActionsPath from '../../modules/dependencies/NeosAICore/images/QuickActions.svg'
import renamePath from '../../modules/Tenants/images/Rename.svg'
import repairPath from '../../modules/Tenants/images/Repair.svg'
import roleUsersPath from '../../modules/Tenants/images/RoleUsers.svg'
import sendPath from '../../modules/Tenants/images/Send.svg'
import settingsPath from '../../modules/Tenants/images/Settings.svg'
import shortenTextPath from '../../modules/dependencies/NeosAICore/images/ShortenText.svg'
import sqlServerPath from '../../modules/Tenants/images/SqlServer.svg'
import statePath from '../../modules/Tenants/images/State.svg'
import stethoscopePath from '../../modules/NeosDiagnostics/images/Stethoscope.svg'
import styleRulePath from '../../modules/UICustomization/images/StyleRule.svg'
import styleRuleDarkVersionPath from '../../modules/UICustomization/images/StyleRule.dark.svg'
import successPath from '../../modules/Tenants/images/Success.svg'
import syncBlackPath from '../../modules/UserPermissions/images/SyncBlack.svg'
import tenantPath from '../../modules/Tenants/images/Tenant.svg'
import tenantsLogoPath from '../../modules/Tenants/images/TenantsLogo.svg'
import translatorPath from '../../modules/dependencies/NeosAICore/images/Translator.svg'
import upPath from '../../modules/UserPermissions/images/Up.svg'
import upToDatePath from '../../modules/Tenants/images/UpToDate.svg'
import upgradePath from '../../modules/Tenants/images/Upgrade.svg'
import userPath from '../../modules/Tenants/images/User.svg'
import userAccountPath from '../../modules/UserPermissions/images/UserAccount.svg'
import userClientPath from '../../modules/UserPermissions/images/UserClient.svg'
import userFunctionPath from '../../modules/UserPermissions/images/UserFunction.svg'
import userPermissionsSendEmailPath from '../../modules/UserPermissions/images/UserPermissionsSendEmail.svg'
import userPermissionsSendSMSPath from '../../modules/UserPermissions/images/UserPermissionsSendSMS.svg'
import userPublisherPath from '../../modules/UserPermissions/images/UserPublisher.svg'
import viewLogPath from '../../modules/Tenants/images/ViewLog.svg'
import warningNotificationPath from '../../modules/NeosNotificationCenter/images/WarningNotification.svg'

const images: Images = {
  aiWritingAssistant: { path: aiWritingAssistantPath, darkVersionPath: aiWritingAssistantDarkVersionPath, colored: true },
  aiWritingAssistantCancel: 'close',
  aiWritingAssistantTaskPerformer: { path: aiWritingAssistantTaskPerformerPath, colored: false },
  aiWritingAssistantValidate: 'validate',
  activeTenantStatus: { path: activeTenantStatusPath, colored: true },
  administratorUserAccountForRequests: { path: administratorUserAccountForRequestsPath, colored: false },
  cancel: 'close',
  chatbot: { path: chatbotPath, colored: true },
  cluster: { path: clusterPath, colored: false },
  clusters: { path: clustersPath, colored: false },
  collapse: { path: collapsePath, colored: false },
  connectivity: { path: connectivityPath, colored: false },
  copy: { path: copyPath, colored: false },
  correctText: { path: correctTextPath, colored: false },
  createCustomView: { path: createCustomViewPath, darkVersionPath: createCustomViewDarkVersionPath, colored: true },
  customView: { path: customViewPath, colored: false },
  customViewDefaultView: { path: customViewDefaultViewPath, colored: false },
  customViewFilter: { path: customViewFilterPath, colored: false },
  customViewGroups: { path: customViewGroupsPath, colored: false },
  customViewKey: { path: customViewKeyPath, colored: false },
  customViewProperty: { path: customViewPropertyPath, colored: false },
  customViewRelationship: { path: customViewRelationshipPath, colored: false },
  customViewSave: { path: customViewSavePath, colored: false },
  customViewSelected: { path: customViewSelectedPath, colored: false },
  customViewSetDefaultView: { path: customViewSetDefaultViewPath, colored: false },
  customViewSort: { path: customViewSortPath, colored: false },
  dataCreator: 'add',
  database: { path: databasePath, colored: true },
  databaseConnectionTest: { path: databaseConnectionTestPath, darkVersionPath: databaseConnectionTestDarkVersionPath, colored: true },
  databaseSync: { path: databaseSyncPath, colored: true },
  disableNotifications: { path: disableNotificationsPath, colored: false },
  down: { path: downPath, colored: false },
  downgrade: { path: downgradePath, colored: false },
  edit: 'edit',
  editCustomView: { path: editCustomViewPath, darkVersionPath: editCustomViewDarkVersionPath, colored: true },
  editUser: 'edit',
  enableNotifications: { path: enableNotificationsPath, colored: false },
  error: 'error',
  errorCluster: { path: errorClusterPath, colored: true },
  errorNotification: 'danger',
  expand: { path: expandPath, colored: false },
  extendedEntity: { path: extendedEntityPath, colored: true },
  externalCluster: { path: externalClusterPath, colored: true },
  eye: { path: eyePath, colored: false },
  eyeOff: { path: eyeOffPath, colored: false },
  failure: { path: failurePath, colored: true },
  id: { path: idPath, colored: false },
  improveText: { path: improveTextPath, colored: false },
  inactiveTenantStatus: { path: inactiveTenantStatusPath, colored: true },
  info: 'info',
  infoNotification: 'info',
  license: { path: licensePath, colored: false },
  menu: 'menu',
  messagePublicationCancel: 'close',
  multiTenant: { path: multiTenantPath, colored: false },
  neos: { path: neosPath, colored: true },
  neosBarChart: { path: neosBarChartPath, colored: true },
  neosDashboard: { path: neosDashboardPath, colored: false },
  neosDashboardAdd: { path: neosDashboardAddPath, colored: false },
  neosDashboardClock: { path: neosDashboardClockPath, colored: false },
  neosDashboardDisplay: { path: neosDashboardDisplayPath, colored: false },
  neosDashboardDoughnutChart: { path: neosDashboardDoughnutChartPath, colored: true },
  neosDashboardEditDashboard: { path: neosDashboardEditDashboardPath, colored: false },
  neosDashboardExpandView: { path: neosDashboardExpandViewPath, colored: false },
  neosDashboardGaugeChart: { path: neosDashboardGaugeChartPath, colored: true },
  neosDashboardHome: { path: neosDashboardHomePath, colored: false },
  neosDashboardLineChart: { path: neosDashboardLineChartPath, colored: true },
  neosDashboardNoneChart: { path: neosDashboardNoneChartPath, colored: false },
  neosDashboardPieChart: { path: neosDashboardPieChartPath, colored: true },
  neosDashboardSetting: { path: neosDashboardSettingPath, colored: false },
  neosDashboardShared: { path: neosDashboardSharedPath, colored: false },
  neosDashboardTile: { path: neosDashboardTilePath, colored: false },
  neosDashboardTileChart: { path: neosDashboardTileChartPath, colored: false },
  neosDataImportAdd: 'add',
  neosDataImportClose: 'close',
  neosDataImportDetail: { path: neosDataImportDetailPath, colored: false },
  neosDataImportDownloadFile: { path: neosDataImportDownloadFilePath, colored: false },
  neosDataImportError: { path: neosDataImportErrorPath, colored: false },
  neosDataImportFile: { path: neosDataImportFilePath, colored: false },
  neosDataImportFilter: 'filter',
  neosDataImportHistory: { path: neosDataImportHistoryPath, colored: false },
  neosDataImportInfo: 'info',
  neosDataImportIntegrate: { path: neosDataImportIntegratePath, colored: false },
  neosDataImportIntegrateAll: { path: neosDataImportIntegrateAllPath, colored: false },
  neosDataImportIntegration: { path: neosDataImportIntegrationPath, colored: false },
  neosDataImportKpiErrorRowCount: { path: neosDataImportKpiErrorRowCountPath, colored: true },
  neosDataImportKpiInformationRowCount: { path: neosDataImportKpiInformationRowCountPath, colored: true },
  neosDataImportKpiIntegratedRowCount: { path: neosDataImportKpiIntegratedRowCountPath, colored: true },
  neosDataImportKpiProcessedRowCount: { path: neosDataImportKpiProcessedRowCountPath, colored: true },
  neosDataImportKpiValidRowCount: { path: neosDataImportKpiValidRowCountPath, colored: true },
  neosDataImportKpiWarningRowCount: { path: neosDataImportKpiWarningRowCountPath, colored: true },
  neosDataImportRightArrow: { path: neosDataImportRightArrowPath, colored: false },
  neosDataImportRun: { path: neosDataImportRunPath, colored: false },
  neosDataImportSettings: { path: neosDataImportSettingsPath, colored: false },
  neosDataImportTemplate: { path: neosDataImportTemplatePath, colored: false },
  neosDataImportUploadFile: { path: neosDataImportUploadFilePath, colored: false },
  neosDataImportValidate: 'validate',
  neosDiagnosticsAdminUserAccount: { path: neosDiagnosticsAdminUserAccountPath, colored: false },
  neosDiagnosticsDownload: { path: neosDiagnosticsDownloadPath, colored: false },
  neosDiagnosticsLaunch: { path: neosDiagnosticsLaunchPath, colored: false },
  neosDiagnosticsOpenInNew: { path: neosDiagnosticsOpenInNewPath, colored: false },
  neosDiagnosticsUserAccount: { path: neosDiagnosticsUserAccountPath, colored: false },
  neosPrint: 'print',
  notificationCenter: { path: notificationCenterPath, colored: false },
  notificationCenterCardCollapsed: 'chevronRight',
  notificationCenterCardExpanded: 'chevronDown',
  notificationCenterEmpty: { path: notificationCenterEmptyPath, colored: false },
  omnia: { path: omniaPath, colored: true },
  openInNew: { path: openInNewPath, colored: false },
  oracle: { path: oraclePath, colored: true },
  performTaskOnText: { path: performTaskOnTextPath, colored: false },
  postGre: { path: postGrePath, colored: true },
  property: { path: propertyPath, colored: false },
  querya: { path: queryaPath, colored: true },
  quickActions: { path: quickActionsPath, colored: false },
  removeNotification: 'close',
  rename: { path: renamePath, colored: false },
  repair: { path: repairPath, colored: false },
  resetTenantCache: 'clear',
  roleUsers: { path: roleUsersPath, colored: false },
  save: 'save',
  send: { path: sendPath, colored: false },
  settings: { path: settingsPath, colored: false },
  shortenText: { path: shortenTextPath, colored: false },
  sqlServer: { path: sqlServerPath, colored: true },
  state: { path: statePath, colored: false },
  stethoscope: { path: stethoscopePath, colored: false },
  styleRule: { path: styleRulePath, darkVersionPath: styleRuleDarkVersionPath, colored: true },
  success: { path: successPath, colored: true },
  successNotification: 'positive',
  syncBlack: { path: syncBlackPath, colored: false },
  tenant: { path: tenantPath, colored: false },
  tenantsLogo: { path: tenantsLogoPath, colored: false },
  translator: { path: translatorPath, colored: false },
  up: { path: upPath, colored: false },
  upToDate: { path: upToDatePath, colored: true },
  upgrade: { path: upgradePath, colored: false },
  user: { path: userPath, colored: false },
  userAccount: { path: userAccountPath, colored: false },
  userClient: { path: userClientPath, colored: false },
  userFunction: { path: userFunctionPath, colored: false },
  userPermissionsSendEmail: { path: userPermissionsSendEmailPath, colored: false },
  userPermissionsSendSMS: { path: userPermissionsSendSMSPath, colored: false },
  userPublisher: { path: userPublisherPath, colored: false },
  validate: 'validate',
  vasco: 'open',
  viewLog: { path: viewLogPath, colored: false },
  warning: 'warning',
  warningNotification: { path: warningNotificationPath, colored: false },
}

export default images